export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/invitation_design.2d663c3.svg";